import Button from "components/general/buttonv2";
import {
  StyledBody,
  StyledContainer,
  StyledHalfImage,
  StyledSvgWrapper,
  StyledWrapper,
} from "components/general/stylingHero";
import SvgIcon from "components/general/svgIcon";
import asyncComponent from "components/split/asyncComponent";
import { heroData } from "data/homeData";
import { downloadLinksArray, downloadsDisabled, genericDownloadLink } from "data/variables";
import { gtag_report_download } from "lib/ga";
import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";
import styled from "styled-components";
const SvgRocket = asyncComponent(() => import("components/download/svgRocket"));

const StyledSubtext = styled.div`
  margin-top: 1rem;
  color: var(--text-color);
  font-size: 1rem;
`;
const StyledButtonRow = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    svg {
      margin-top: 1rem;
    }
  }
`;
const StyledButtonRowIcons = styled.div`
  display: flex;
  margin-left: 2rem;
  @media screen and (max-width: 992px) {
    margin-top: 1rem;
    margin-left: 0;
  }
`;
const StyledIcon = styled.a`
  margin-right: 1.5rem;
  cursor: ${(props) => props["data-disabled"] && "default"};
  pointer-events: ${(props) => props["data-disabled"] && "none"};
  @media screen and (max-width: 768px) {
    margin-right: 0.5rem;
  }
  svg,
  path {
    height: 2rem;
    width: auto;
    fill: var(--text-color);
    ${(props) =>
      props["data-disabled"] &&
      `
      fill: rgba(222, 222, 222, 1);
    `}
  }
`;
const StyledCatSvg = styled(SvgRocket)`
  height: 500px;
  width: 100%;
  @media screen and (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

function getDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return "Android";
  }

  return "unknown";
}

const Hero = () => {
  const [deviceState, setDeviceState] = useState(null);
  const [hasDownloaded, setHasDownloaded] = useState(false);

  const posthog = usePostHog();

  useEffect(() => {
    const device = getDevice && getDevice();

    if (device === "iOS" || device === "Android") {
      setDeviceState(device);
    }
  }, []);

  const getLink = () => {
    if (deviceState) {
      if (deviceState == "iOS") {
        return "https://apps.apple.com/us/app/redact-privacy/id6449900531";
      }
      return "https://play.google.com/store/apps/details?id=dev.redact.app";
    }
    return genericDownloadLink;
  };

  return (
    <StyledWrapper marginBottom="6rem">
      <StyledContainer>
        <div className="hero__half">
          <h1 className="hero__title">Click below to download Redact!</h1>
          <StyledBody>{heroData.subtitle}</StyledBody>
          <StyledButtonRow>
            <Button
              disabled={downloadsDisabled}
              buttonPrimary={true}
              trackClick={true}
              onClick={() => {
                gtag_report_download();

                posthog.capture("download");
                window.location.href = getLink();
              }}
              data-action-name="Download Hero: Install"
            >
              Download
            </Button>
            <StyledButtonRowIcons>
              {downloadLinksArray.map((value) => {
                if (value.external) {
                  return (
                    <a
                      key={"" + value.link + value.external + value.icon}
                      className={`hero__button_row__icon ${
                        value.disabled ? "hero__button_row__icon--disabled" : ""
                      }`}
                      data-action-name={`Download Hero: ${value.actionName || value.icon}`}
                      href={value.link}
                      onClick={() => {
                        gtag_report_download();

                        posthog.capture("download");
                        return true;
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <SvgIcon name={value.icon} />
                    </a>
                  );
                }
                return (
                  <StyledIcon
                    data-disabled={value.disabled}
                    data-action-name={`Download Hero: ${value.actionName || value.icon}`}
                    href={value.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={"" + value.icon + value.link}
                  >
                    <SvgIcon name={value.icon} />
                  </StyledIcon>
                );
              })}
            </StyledButtonRowIcons>
          </StyledButtonRow>
          <StyledSubtext>{heroData.downloadText}</StyledSubtext>
        </div>
        <StyledHalfImage>
          <StyledSvgWrapper>
            <StyledCatSvg />
          </StyledSvgWrapper>
        </StyledHalfImage>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
